import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';

export interface ClaimStatusOption {
  id: number;
  code: string;
  label: string;
  color: string;
}

export const claimStatusKeys = {
  all:  ['claim-statuses'] as const,
  list: (jobTypeCode: string) => [...claimStatusKeys.all, jobTypeCode] as const,
};

/** Tenant's merged (superadmin + tenant-added) claim status list for a usecase. */
export function useClaimStatuses(jobTypeCode: string) {
  return useQuery({
    queryKey: claimStatusKeys.list(jobTypeCode),
    queryFn:  () => apiClient.listClaimStatuses(jobTypeCode) as Promise<ClaimStatusOption[]>,
    staleTime: 60_000,
  });
}
